import { Country } from '@afterpay/types'
import { TerminalErrorCode } from '../../model'
import { TrackingEvent } from '../../model/monitoring'
import { AlternativeOptionType, LinkAmpEvent } from './types'
import { IllustrationName, ILLUSTRATIONS } from '../Illustration'

export const TERMINAL_ERROR_CODE_IMAGE_MAP: { [key in TerminalErrorCode]?: IllustrationName } = {
  [TerminalErrorCode.Default]: ILLUSTRATIONS.CoffeeSpill,
}

export const getLinkAmpEvent = (error: string, url?: string): LinkAmpEvent => ({
  event: TrackingEvent.PRESSED_TERMINAL_ERROR_LINK,
  options: { error, targetUrl: url ?? '' },
})

export const isAlternativeOptionTypeArray = (candidate: unknown): candidate is AlternativeOptionType[] => {
  if (!Array.isArray(candidate) || candidate.length === 0) {
    return false
  }
  return candidate.every((item) => item && typeof item.title === 'string')
}

export interface ShouldHideDescriptionParams {
  isOrderAmountExceedsSpendCap: boolean
  errorKey: TerminalErrorCode
  country: Country
}

export const shouldHideDescription = (params: ShouldHideDescriptionParams): boolean => {
  const { isOrderAmountExceedsSpendCap, errorKey, country } = params

  const isOrderAmountTooHighError = errorKey === TerminalErrorCode.OrderAmountTooHigh
  const isOrderAmountTooHighErrorForGB = isOrderAmountTooHighError && country === Country.GB

  if ([isOrderAmountTooHighErrorForGB].some((condition) => condition)) {
    return false
  }

  if ([isOrderAmountExceedsSpendCap, isOrderAmountTooHighError].some((condition) => condition)) {
    return true
  }

  return false
}
